import Vue from 'vue';
import Vuex from 'vuex';

import UrlTemplate from 'url-template';

const extractJson = res => res.json();

const getFetch = (url, options = {}) => {
	const { method, body } = options;
	const requestHeader = {
		'Content-Type': 'application/json',
	};

	const params = {
		method: method || 'GET',
		headers: requestHeader,
	};

	if (body) {
		params.body = JSON.stringify(body);
	}

	return fetch(url, params);
};

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		page: {},
		pages: [],
		notice: null,
		noticegt3weeks: null,
		commicement: null,
		commicementgt6months: null,
		before2004: null,
		isLoading: false,
		isSending: false,
		isGenerating: false,
		sendSuccess: false,
		sendError: false,
		codeError: false,
		embedCode: '',
	},
	mutations: {
		pageUpdate(state, page) {
			const savedPage = state.pages.find(p => p.id === page.id);

			if (!savedPage) {
				state.pages = [...state.pages, ...[page]];
			}
			state.page = page;
			state.isLoading = false;
		},
		pageRequested(state) {
			state.isLoading = true;
		},
		pageError(state) {
			state.isLoading = false;
		},
		noticeUpdate(state, { date, noticegt3weeks }) {
			state.notice = date;
			state.noticegt3weeks = noticegt3weeks;
		},
		commicementUpdate(state, { date, commicementgt6months, before2004 }) {
			state.commicement = date;
			state.commicementgt6months = commicementgt6months;
			state.before2004 = before2004;
		},
		sendRequested(state) {
			state.isSending = true;
		},
		sendResult(state, status) {
			state.isSending = false;
			state.sendSuccess = false;
			state.sendError = false;

			if (status === 200) {
				state.sendSuccess = true;
			} else {
				state.sendError = true;
			}
		},
		resetResult(state) {
			state.isSending = false;
			state.sendSuccess = false;
			state.sendError = false;
		},
		codeRequested(state) {
			state.isGenerating = true;
		},
		codeGenerated(state, result) {
			const { status, code } = result;
			state.isGenerating = false;
			state.codeError = false;

			if (status === 200) {
				state.embedCode = code;
			} else {
				state.codeError = true;
			}
		},
	},
	actions: {
		getPage({ state, commit }, pageId) {
			commit('pageRequested');
			const page = state.pages.find(p => p.id === pageId);

			if (page) {
				commit('pageUpdate', page);
				return;
			}

			const url = UrlTemplate.parse(window.env.PAGES_ENDPOINT).expand({
				id: pageId,
			});
			getFetch(url)
				.then(extractJson)
				.then(res => {
					commit('pageUpdate', res);
				})
				.catch(() => {
					commit('pageError');
				});
		},
		sendMail({ state, commit }, body) {
			commit('sendRequested');
			const params = new URLSearchParams(window.location.search);

			if (params.has('email')) {
				Object.assign(body, {
					to: params.get('email'),
				});
			}

			getFetch(window.env.SEND_ENDPOINT, {
				method: 'POST',
				body,
			})
				.then(extractJson)
				.then(({ status }) => commit('sendResult', status));
		},
		setNotice({ commit }, params) {
			commit('noticeUpdate', params);
		},
		setCommicement({ commit }, params) {
			commit('commicementUpdate', params);
		},
		resetResult({ commit }) {
			commit('resetResult');
		},
		generateCode({ commit }, params) {
			commit('codeRequested');
			getFetch(window.env.GENERATE_ENDPOINT, {
				method: 'POST',
				body: Object.assign(params, {
					host: location.origin,
				}),
			})
				.then(extractJson)
				.then(res => commit('codeGenerated', res));
		},
	},
});
